import { render, staticRenderFns } from "./PlaidSection.vue?vue&type=template&id=1f8aad36&scoped=true"
import script from "./PlaidSection.vue?vue&type=script&lang=ts"
export * from "./PlaidSection.vue?vue&type=script&lang=ts"
import style0 from "./PlaidSection.vue?vue&type=style&index=0&id=1f8aad36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8aad36",
  null
  
)

export default component.exports